module.exports = __webpack_public_path__ + "img/06-illu-matome2021.b524106d.png";